<template>
  <div class="search-filters"
    :class="{'search-filters--active': $store.getters['filtersActive']}">
    <div class="search-filters__inner container">
      <h3 class="search-filters__title" v-if="getTitle" v-html="getTitle"></h3>
      <button @click="$store.dispatch('deactivateFilters')" class="search-filters__close"><i class="icon-clear" :aria-label="getAriaClearLabel"></i></button>

      <SearchFiltersItem
        v-for="(filter, index) in filters"
        :key="index"
        :type="filter.type"
        :name="filter.name"
        :items="filter.items"
        :taxonomy="filter.taxonomy"
      />
    </div>
  </div>
</template>

<script>
import SearchFiltersItem from './search-filters-item'
export default {
  data() {
    return {
      active: false
    }
  },
  components: {
    SearchFiltersItem
  },
  props: {
    filters: {
      type: Array,
      required: true
    }
  },
  computed: {
    getTitle() {
        return wp_variables.search.title;
    },
    getAriaClearLabel() {
        return wp_variables.search.clear_label;
    }
  }
}
</script>
